// extracted by mini-css-extract-plugin
module.exports = {"positive":"Shift_positive_5RC_9","negative":"Shift_negative_15B0_"};